import { render, staticRenderFns } from "./HospitalConnectionTag.vue?vue&type=template&id=cec8f088&scoped=true&"
import script from "./HospitalConnectionTag.vue?vue&type=script&lang=js&"
export * from "./HospitalConnectionTag.vue?vue&type=script&lang=js&"
import style0 from "./HospitalConnectionTag.vue?vue&type=style&index=0&id=cec8f088&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec8f088",
  null
  
)

export default component.exports